import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { dsQuery } from "../query";

export const fetchObservationSheetPdf = async (params) => {
  try {
    // Check if params.id contains comma-separated values
    const ids = params.id ? params.id.split(",").map((id) => id.trim()) : [];
    if (ids.length === 0) {
      console.error("No valid IDs provided");
      return [];
    }
    // Convert array of IDs to comma-separated string for SQL IN clause
    const idList = ids
      ?.map((id) => parseInt(id))
      ?.filter((id) => !isNaN(id))
      ?.join(",");

    if (!idList) {
      console.error("No valid IDs after parsing");
      return [];
    }

   // Fetch active roles directly inside the function
    const results = await fetchQuery(`${dsQuery} WHERE observationSheet.id IN (${idList}) ORDER BY observationSheet.id;`);


    // For each observationSheet, fetch static tables and reading rows, then combine all
    const modifiedResults = await Promise.all(
      (results || []).map(async (item) => {
        const observationConfig =
          typeof item.observationSheet_configuration === "string"
            ? JSON.parse(item.observationSheet_configuration || "{}")
            : item.observationSheet_configuration;

        // Fetch observationSheetTables and readingRows for this item
        const staticTables = await fetchobservationSheetStaticTables(item.materialTestings_materialId, item.observationSheet_testId, item.deletedTableIds || "");
        const readingRows = await fetchStaticReadingRows(item.id);

        return {
          ...item,
          observationSheet_configuration: observationConfig,
          staticTables,
          readingRows,
        };
      })
    );

    return modifiedResults || [];
  } catch (error) {
    console.error("Error fetching observationSheets:", error);
    return [];
  }
};

// Return promise with tables instead of setState
export function fetchobservationSheetStaticTables(materialId, testId, deletedTableIds = []) {
  deletedTableIds = deletedTableIds?.split?.(",")?.map((id) => Number(id)) || [];

  return axiosWithToken
    .get(BASE_URL + `observationTemplates?_where=(materialId,eq,${materialId})~and(testId,eq,${testId})~and(status,eq,1)`)
    .then((res) => {
        let tables = res.data || [];
      if (deletedTableIds.length > 0) {
        tables = tables.filter((row) => !deletedTableIds.includes(row.id));
      }
      tables = tables.map((table) => ({
        ...table,
        defaultConfiguration: JSON.parse(table?.defaultConfiguration || null),
      }));
      return tables;
    })
    .catch((err)=> console.log("error observationSheetStaticTables "+ err));
}


export function fetchStaticReadingRows(observationSheetId) {
  let url = BASE_URL;
  return axiosWithToken
    .get(url + `observationSheetReadings?_where=(observationsheetId,eq,${observationSheetId})`)
    .then((res) => res.data || [])
    .catch((err)=> console.log("datasheetStaticReadings observationSheetStaticTables "+ err));
}
